// extracted by mini-css-extract-plugin
module.exports = {"plusButton":"ButtonPlus_plusButton__1Wo8H"};